import App from '../../../vendor_core/core/src/App';
import LocalStorageVars from '../../../vendor_core/core/src/const/LocalStorageVars';
import SoundVars from '../../../vendor_core/core/src/const/SoundVars';
import AutoplayModel from '../../../vendor_core/core/src/model/AutoplayModel';
import BuyFeatureModel from '../../../vendor_core/core/src/model/BuyFeatureModel';
import { Tween } from '../../../vendor_core/core/src/Tween';
import LocalData from '../../../vendor_core/core/src/utils/LocalData';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import IdleState from "../../../vendor_core/src/states/IdleState";
import DoubleChanceModel from '../../model/DoubleChanceModel';
import GameSoundVars from '../enums/GameSoundVars';

export default class TRWIdleState extends IdleState {
    protected soundFaded: boolean = false;

    private soundTransitionInactiveDelay: number = 10.0;
    private soundTransitionFadeInDuration: number = 3.0;

    public enter(): void {
        BuyFeatureModel.mode = DoubleChanceModel.isActivated ? 1 : -1;

        if (!AutoplayModel.isAutoSpinActive()) {
            Tween.delayedCall(LocalData.getBooleanValue(LocalStorageVars.MUSIC_ENABLED) ? this.soundTransitionInactiveDelay : 0, this.playIdleMusic, [], this);
        }

        super.enter();
    }
    
    public exit(): void {
        this.restartMusicPlayback();
        super.exit();
    }
    
    protected playIdleMusic(): void {
        if (!this.soundFaded && App.config.soundVolumeOverride) {
            SoundController.fadeMusic(App.config.soundVolumeOverride[SoundVars.MUSIC_MAIN], 0, this.soundTransitionFadeInDuration, [SoundVars.MUSIC_MAIN]);
            SoundController.playMusic(GameSoundVars.IDLE_MUSIC, 0, false, [], true);
            SoundController.fadeMusic(0, App.config.soundVolumeOverride[GameSoundVars.IDLE_MUSIC], 1.7, [GameSoundVars.IDLE_MUSIC]);

            this.soundFaded = true;
        }
    }
    

    protected restartMusicPlayback(): void {
        Tween.killDelayedCallsTo(this.playIdleMusic);

        if (this.soundFaded && App.config.soundVolumeOverride) {
            SoundController.fadeMusic(App.config.soundVolumeOverride[GameSoundVars.IDLE_MUSIC], 0, this.soundTransitionFadeInDuration, [GameSoundVars.IDLE_MUSIC]);
            SoundController.playMusic(SoundVars.MUSIC_MAIN, 0, false, [], true);
            SoundController.fadeMusic(0, App.config.soundVolumeOverride[SoundVars.MUSIC_MAIN], 0.7, [SoundVars.MUSIC_MAIN]);
            this.soundFaded = false;
        }
    }
}
